<div class="login-container">
  <!-- 完了メッセージ -->
  <div class="form-box" *ngIf="showCompletionMessage">
    <div class="success-icon-container">
      <i class="fa fa-check-circle"></i>
    </div>
    <h2>LINE連携が完了しました</h2>
    <p>この画面は閉じて大丈夫です</p>
  </div>

  <!-- ログインフォーム -->
  <div class="form-box" *ngIf="!showCompletionMessage">
    <h2>LINEアカウント連携</h2>
    <div class="user-icon-container">
      <img class="logo-img" src="assets/img/logo.png" alt="Logo">
    </div>
    <form method="post">
      <div class="input-group">
        <input type="email" name="email" placeholder="メールアドレス" [(ngModel)]="email" required>
      </div>
      <div class="input-group">
        <input type="password" name="password" placeholder="パスワード" [(ngModel)]="password" required>
      </div>
      <button class="btn-primary-dark" type="submit" (click)="linkLine()">LINE連携を行う</button>
    </form>
  </div>

  <!-- ローディング表示 -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loading-spinner"></div>
    <p>LINEログインを初期化中...</p>
  </div>

  <!-- エラーメッセージ -->
  <div class="error-toast" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>
</div> 